module.exports = __webpack_public_path__ + "img/17.b56372c0.jpg";